import React, { useState, useEffect } from 'react';
import Quiz from './Quiz';

import '../css/estilos.css';

const Home = () => {
  const [showHeader, setShowHeader] = useState(true);

  useEffect(() => {
    const showHeaderStored = localStorage.getItem('showHeader');
    if (showHeaderStored === 'false') {
      setShowHeader(false);
    }
  }, []);

  const handleQuizComplete = () => {
    setShowHeader(false);
    localStorage.setItem('showHeader', 'false');
  };

  return (
    <div style={{ fontFamily: 'Work Sans, sans-serif' }}>
    
        {/* Encabezado */}
        {showHeader && (
          <div className="quiz-pantalla-principal">
            <div className="logotipo-el-universal">
              {/* <img
                style={{ height: '38px', width: 'auto' }}
                src={logoUniversal}
                alt="Logotipo El Universal"
              /> */}
            </div>

            <div className="introduccion">
        
              <p className="titulo-quiz">
                ¿Te pareces más <br />a{' '}
                <span style={{ color: '#3382AF' }}>Claudia</span> o{' '}
                <span style={{ color: '#3382AF' }}>Xóchitl</span>?
              </p>
              <p className="descripcion-quiz">
                Es momento de definir esto, contesta 10 preguntas para saber de
                qué lado de la historia estás.
              </p>
            </div>
          </div>
        )}

        {/* Contenido del quiz */}
        <Quiz onQuizComplete={handleQuizComplete} />

      
    </div>
  );
};

export default Home;
